// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__2lDon","load2":"Spinner_load2__30wSl"};